<template>
    <div class="mt-3">
        <div class="flex flex-col gap-3 md:grid md:grid-cols-3 md:items-center">
            <div class="hidden md:block"></div>
            <h1 class="text-3xl text-center">
                Carros de compras registrados
                <strong class="text-theme-primary">
                    {{ itemsNumber }}
                </strong>
            </h1>
            <div class="flex justify-center md:justify-end">
                <app-button
                    v-if="$ability.hasPermission('cart:Create')"
                    color="success"
                    size="large"
                    @click="$router.push('/app/cart/new')"
                >
                    <span class="hidden md:inline">Nuevo carrito</span>
                    <span class="md:hidden font-bold">+</span>
                </app-button>
            </div>
        </div>

        <div class="flex justify-between flex-col lg:flex-row">
            <div class="my-3 flex justify-around">
                <app-button relief @click="reloadItems">
                    Consultar 🔎
                </app-button>
            </div>

            <div class="my-3 flex items-center justify-around">
                <tooltip-button
                    v-show="
                        selected.length && $ability.hasPermission('cart:Create')
                    "
                    icon="🗂️"
                    message="Clonar carro"
                    @click="cloneSelected"
                />
                <custom-pagination
                    v-model="currentPage"
                    :length="pagesNumber"
                    @input="listItems()"
                />
            </div>
        </div>

        <div class="w-full mt-2">
            <custom-table
                :fields="$data.$fields"
                :items="itemsCurrent"
                :per-page="itemsCurrent.length"
                select-mode="single"
                selectable
                responsive
                outlined
                no-border-collapse
                hover
                class="w-full"
                items-empty-message="Nuestro sistema NO encuentra resultados. Intenta modificar los filtros de búsqueda."
                @flex-selected="onRowSelected"
            >
                <template #cell(id)="data">
                    <div class="flex items-center">
                        <router-link
                            :to="`/app/carts/detail/${data.item.id}`"
                            class="text-center btn btn-stack-primary p-1"
                        >
                            <span>
                                {{ data.item.id }}
                            </span>
                        </router-link>
                    </div>
                </template>

                <template #cell(name)="data">
                    <span class="text-center">
                        {{ data.item.name }}
                    </span>
                </template>

                <template #cell(seller)="data">
                    <div
                        v-if="data.item.seller"
                        class="flex flex-col gap-1.5 py-1"
                    >
                        <div class="flex items-center gap-2">
                            <span
                                class="text-sm font-medium text-theme-primary"
                            >
                                {{ data.item.seller.firstName }}
                                {{ data.item.seller.lastName }}
                            </span>
                        </div>
                        <div class="flex items-center gap-1.5">
                            <span class="text-xs font-medium"> ✉️ </span>
                            <span class="text-xs font-mono">
                                {{ data.item.seller.email }}
                            </span>
                        </div>
                    </div>
                    <div v-else class="flex items-center gap-1.5 py-1">
                        <span
                            class="text-xs italic text-theme-muted bg-theme-hover px-2 py-1 rounded-md"
                        >
                            Sin vendedor asociado
                        </span>
                    </div>
                </template>

                <template #cell(updatedAt)="data">
                    <span class="text-center">
                        {{ data.item.updatedAt | date }}
                    </span>
                </template>
            </custom-table>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

import CustomTable from "@/components/utils/CustomTable.vue";
import TooltipButton from "@/components/utils/TooltipButton.vue";

export default {
    name: "CartsIndex",
    components: {
        TooltipButton,
        CustomTable
    },
    layout: "app",
    data: () => ({
        keySearch: "",
        itemsCurrent: [],
        cartsTotal: [],
        selected: [],
        $fields: [
            { key: "id", label: "ID", sortable: false },
            { key: "name", label: "Nombre", sortable: true },
            { key: "seller", label: "Vendedor", sortable: false },
            { key: "updatedAt", label: "📆 Actualización", sortable: true }
        ],

        currentPage: 1,
        pagesNumber: 0,
        itemsNumber: 0
    }),
    computed: {
        ...mapState("commons", ["selectedMerchant"]),
        ...mapGetters("control", ["backgroundColor"])
    },
    watch: {},
    async mounted() {
        const verifyPagePermission =
            this.$ability.verifyPagePermission.bind(this);
        if (!(await verifyPagePermission("cart:List", "/app"))) return;
        this.listItems(true);
    },
    methods: {
        ...mapActions("carts", ["listCartsPaginated"]),
        async listItems(complete = false) {
            this.isLoading = true;
            this.$loading.show();
            try {
                const { items, pagination } = await this.listCartsPaginated({
                    page: this.currentPage,
                    complete
                });
                this.itemsCurrent = items;
                if (pagination) {
                    this.itemsNumber = pagination.itemsNumber;
                    this.pagesNumber = pagination.pagesNumber;
                }
                this.$loading.hide();
            } catch (error) {
                this.$loading.hide();
                this.isLoading = false;
                this.$swal.fire({
                    background: this.backgroundColor,
                    title: error.title,
                    text: error.message,
                    icon: error.icon
                });
            }
        },
        async reloadItems() {
            this.currentPage = 1;
            await this.listItems(true);
        },
        onRowSelected(items) {
            this.selected = items;
        },
        clearSelected() {
            this.$refs.selectableTable.clearSelected();
            this.selected = [];
        },
        cloneSelected() {
            window
                .open(`/app/carts/clone/${this.selected[0].id}`, "_blank")
                .focus();
        }
    }
};
</script>
